import { VoiceMessageBuilder } from './voice-message.builder';
var defaultDailyActivity = {
    start: [8, 0, 0, 0],
    end: [18, 0, 0, 0],
    enabled: true
};
var BusinessHoursBuilder = /** @class */ (function () {
    function BusinessHoursBuilder() {
        this.businessHours = {
            openTwentyFourSeven: false,
            offHoursMessage: new VoiceMessageBuilder().build(),
            sunday: defaultDailyActivity,
            monday: defaultDailyActivity,
            tuesday: defaultDailyActivity,
            wednesday: defaultDailyActivity,
            thursday: defaultDailyActivity,
            friday: defaultDailyActivity,
            saturday: defaultDailyActivity
        };
    }
    BusinessHoursBuilder.prototype.withDayData = function (day, data) {
        this.businessHours[day] = data;
        return this;
    };
    BusinessHoursBuilder.prototype.withOffHoursMessage = function (offHoursMessage) {
        this.businessHours.offHoursMessage = offHoursMessage;
        return this;
    };
    BusinessHoursBuilder.prototype.withOpenTwentyFourSeven = function (openTwentyFourSeven) {
        this.businessHours.openTwentyFourSeven = openTwentyFourSeven;
        return this;
    };
    BusinessHoursBuilder.prototype.build = function () {
        return this.businessHours;
    };
    return BusinessHoursBuilder;
}());
export { BusinessHoursBuilder };
//# sourceMappingURL=business-hours.builder.js.map